import React from 'react';


const tagStyle = ({ color }) => ({
  padding: '5px',
  backgroundColor: color || 'grey',
  minWidth: '50px',
  color: color === 'yellow' ? 'rgba(0,0,0,0.9)' : 'rgba(255,255,255,0.9)',
  display: 'inline-block',
  fontWeight: 'bold',
  textAlign: 'center',
  cursor: 'pointer',
  marginRight: '10px',
  borderRadius: '4px'
})


const TagCell = ({ tag, handleClick }) => {
  if (!tag) return false;
  const onClick = () => {
    if (!handleClick) return;
    handleClick(tag);
  }
  return (
    <div onClick={onClick}>
      <div style={tagStyle(tag)}>
        <strong>{tag.value}</strong>
      </div>
    </div>
  )
}

export default TagCell;



// WEBPACK FOOTER //
// ./src/components/routes/tags/TagCell.js